module.exports = __webpack_public_path__ + "img/logout_icon.6ef49d42.png";